var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-score-card',{key:"QScoreCardUniqueLeadTakers",attrs:{"title":"Unique Lead Takers","api-endpoint":"unique_lead_takers","drill-down-route":"","card-style":"leads","agent-code":_vm.agentCode,"filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }